import './less/style.less';

import Accordion from './js/accordion/index';
import Activation from './js/activate/index';
import Card from './js/card/index';
import Carousel from './js/carousel/index';
import Checkout from './js/checkout/index';
import Navigation from './js/nav/index';
import Product from './js/product/index';
import Utils from './js/utils/index';

if (module.hot) {
    module.hot.accept();
}

const $ = jQuery;

Accordion($).init();
Activation().init();
Card($).init();
Carousel($).init();
Checkout($).init();
Navigation($).init();
Product($).init();
Utils($).init();
